/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AccountPrivateGatewayNumberStatusDto } from '../models/AccountPrivateGatewayNumberStatusDto';
import type { AccountPurchasedSmsPackageDtoListResult } from '../models/AccountPurchasedSmsPackageDtoListResult';
import type { CreateSmsCampaignInput } from '../models/CreateSmsCampaignInput';
import type { CreateSmsTemplateInput } from '../models/CreateSmsTemplateInput';
import type { ExcelFileResultDto } from '../models/ExcelFileResultDto';
import type { GatewayNumberDto } from '../models/GatewayNumberDto';
import type { SmsCampaignDto } from '../models/SmsCampaignDto';
import type { SmsCampaignDtoListResult } from '../models/SmsCampaignDtoListResult';
import type { SmsCampaignRecordDtoListResult } from '../models/SmsCampaignRecordDtoListResult';
import type { SmsPackageDto } from '../models/SmsPackageDto';
import type { SmsTemplateDto } from '../models/SmsTemplateDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class SmsCampaignService {

    /**
     * @param version 
     * @param offset 
     * @returns SmsCampaignDtoListResult OK
     * @throws ApiError
     */
    public static listSmsCampaigns(
version: string,
offset?: number,
): CancelablePromise<SmsCampaignDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign',
            path: {
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns SmsCampaignDto OK
     * @throws ApiError
     */
    public static createSmsCampaign(
version: string,
requestBody?: CreateSmsCampaignInput,
): CancelablePromise<SmsCampaignDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/SmsCampaign',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param smsCampaignId 
     * @param version 
     * @param offset 
     * @param searchTerm 
     * @returns SmsCampaignRecordDtoListResult OK
     * @throws ApiError
     */
    public static getSmsCampaignRecords(
smsCampaignId: number,
version: string,
offset?: number,
searchTerm?: string,
): CancelablePromise<SmsCampaignRecordDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/{smsCampaignId}/Records',
            path: {
                'smsCampaignId': smsCampaignId,
                'version': version,
            },
            query: {
                'offset': offset,
                'searchTerm': searchTerm,
            },
        });
    }

    /**
     * @param version 
     * @returns AccountPrivateGatewayNumberStatusDto OK
     * @throws ApiError
     */
    public static getPrivateGatewayNumbersStatus(
version: string,
): CancelablePromise<AccountPrivateGatewayNumberStatusDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/PrivateGatewayNumbers/Status',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns GatewayNumberDto OK
     * @throws ApiError
     */
    public static listGatewayNumbers(
version: string,
): CancelablePromise<Array<GatewayNumberDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/GatewayNumbers',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @returns SmsPackageDto OK
     * @throws ApiError
     */
    public static listSmsPackages(
version: string,
): CancelablePromise<Array<SmsPackageDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/Packages',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param offset 
     * @returns AccountPurchasedSmsPackageDtoListResult OK
     * @throws ApiError
     */
    public static listPurchasedSmsPackages(
version: string,
offset?: number,
): CancelablePromise<AccountPurchasedSmsPackageDtoListResult> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/Purchased/Packages',
            path: {
                'version': version,
            },
            query: {
                'offset': offset,
            },
        });
    }

    /**
     * @param version 
     * @returns SmsTemplateDto OK
     * @throws ApiError
     */
    public static listSmsTemplates(
version: string,
): CancelablePromise<Array<SmsTemplateDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/user/v{version}/SmsCampaign/Templates',
            path: {
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param requestBody 
     * @returns SmsTemplateDto OK
     * @throws ApiError
     */
    public static addSmsTemplate(
version: string,
requestBody?: CreateSmsTemplateInput,
): CancelablePromise<SmsTemplateDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/SmsCampaign/Template',
            path: {
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param smsTemplateId 
     * @param version 
     * @param requestBody 
     * @returns SmsTemplateDto OK
     * @throws ApiError
     */
    public static updateSmsTemplate(
smsTemplateId: number,
version: string,
requestBody?: CreateSmsTemplateInput,
): CancelablePromise<SmsTemplateDto> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/user/v{version}/SmsCampaign/Template/{smsTemplateId}',
            path: {
                'smsTemplateId': smsTemplateId,
                'version': version,
            },
            body: requestBody,
            mediaType: 'application/json',
        });
    }

    /**
     * @param smsTemplateId 
     * @param version 
     * @returns any OK
     * @throws ApiError
     */
    public static deleteSmsTemplate(
smsTemplateId: number,
version: string,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/user/v{version}/SmsCampaign/Template/{smsTemplateId}',
            path: {
                'smsTemplateId': smsTemplateId,
                'version': version,
            },
        });
    }

    /**
     * @param version 
     * @param formData 
     * @returns ExcelFileResultDto OK
     * @throws ApiError
     */
    public static storeExcelFile(
version: string,
formData?: {
file?: Blob;
},
): CancelablePromise<ExcelFileResultDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/user/v{version}/SmsCampaign/File/Excel',
            path: {
                'version': version,
            },
            formData: formData,
            mediaType: 'multipart/form-data',
        });
    }

}
